var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"placeholder":"请选择数据类型"},on:{"change":_vm.onChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }